<template>
    <div class="home-container" >
        <template v-if="getACCTERMOSUSOAPP == 'N' && getUserAccess?.TERMOSDEUSOAPP == 'S'">
            <div class="termofuse">
                <span class="termtitle" v-text="`Termo de uso de dados`"></span>
                <span class="termtext" v-text="`${getUseTerm || ''}`"></span>
                <div class="inpt-check">
                    <input :name="'termunlock'" :id="'termunlock'" :type="'checkbox'"  :placeholder="'Li e concordo com os termos de uso.'" v-model="termUnlock">
                    <label for="termunlock" v-text="'Li e concordo com os termos de uso.'"></label>
                </div>
                <div class="button-container">
                    <ButtonCenter
                        v-for="(but, key) in termsbuttons"
                        :key="key"
                        :button="but"
                        :disabled="but.display === 'Concordar' && !termUnlock"
                        @click="handleEvent(but)">
                    </ButtonCenter>
                </div>
            </div>
        </template>
        <template v-else-if="(getACCTERMOSUSOAPP == 'S' && getUserAccess?.TERMOSDEUSOAPP == 'S') || (getUserAccess?.TERMOSDEUSOAPP == 'N') || (!getUserAccess?.TERMOSDEUSOAPP)">
            <HomeHeaderComponent></HomeHeaderComponent>
            <CarouselComponent :carrouselItens="dependentsList" :fieldMap="['ICON', 'BALANCE', 'NMCONSUMIDOR']" @componentEvent="dependentEvent"></CarouselComponent>
            <MenuListComponent :homeMenuListItens="homeMenuList" :fieldMap="['icon', 'display']" @componentEvent="handleEvent" :menuVis="getUserAccess"></MenuListComponent>
            <HomeMenuComponent @componentEvent="handleEvent"></HomeMenuComponent>
            <ModalInfo @actionTrue="cardAction" @actionFalse="closeModalInfo" />
            <DependentRegisterComponent @addDependent="addDependent"></DependentRegisterComponent>
        </template>
    </div>
</template>

<script>
/* eslint-disable */
import HomeHeaderComponent from '@/components/header/HomeHeaderComponent.vue'
import CarouselComponent from '@/components/carousel/CarouselComponent.vue'
import MenuListComponent from '@/components/menus/menulist/MenuListComponent.vue'
import HomeMenuComponent from '@/components/menus/HomeMenuComponent.vue'
import ModalInfo from '@/components/modals/ModalInfo.vue'
import DependentRegisterComponent from '@/components/bottom-popups/DependentRegisterComponent.vue'
import { checkConsumerById, registerDependents } from '@/components/controllers/RegisterController'
import { setCardStatus } from '@/components/controllers/CardsController'
import { showSuccessNotification, setAppColors, showErrorNotification } from '@/libs/Util.js'
import { mapGetters, mapActions } from 'vuex'
import ButtonCenter from '@/components/buttons/center/ButtonCenter.vue'

import { doLogOut, blockUser, activateUser } from '@/components/controllers/LoginController.js'
import { updateSonsAfterRecharge } from '@/components/controllers/RechargeController.js'

export default {
    name: 'HomeView',
    components: {
        HomeHeaderComponent,
        CarouselComponent,
        MenuListComponent,
        HomeMenuComponent,
        ButtonCenter,
        ModalInfo,
        DependentRegisterComponent
    },
    data () {
        return {
            currentCDCONSUMIDOR: '',
            termUnlock: false,
            termsbuttons: [
                {
                    display: 'Discordar',
                    action: 'logOutAndBlock'
                },
                {
                    display: 'Concordar',
                    action: 'continue',
                    fill: true
                }
            ],
            messages: []
        }
    },
    computed: {
        ...mapGetters(['dependentsList', 'homeMenuList', 'getUserAccess', 'getACCTERMOSUSOAPP', 'getUseTerm', 'profileFields',
            'getBaseInfo', 'getDefaultPasswordWarning'])
    },
    methods: {
        ...mapActions(['setCurrentDependent', 'showModalInfo', 'closeModalInfo', 'toggleCardStatusCDCONS', 'setDefaultPasswordWarning',
            'setIsInvoiceMode', 'changeDependentMenuVisibility', 'changeDeleteItemVisibility', 'addDependentsData', 'setDependentsData']),

        showDefaultPasswordWarnModal: function () {
            if (this.getDefaultPasswordWarning.DEFAULT) {
                this.setDefaultPasswordWarning(false)
                this.showModalInfo({
                    type: 'default',
                    text: 'Favor alterar a senha para maior segurança.',
                    icon: 'fas fa-lock',
                    open: true
                })
            }
        },
        handleEvent: async function (ev) {
            if (ev.action === 'logOut') {
                doLogOut()
            } else if (ev.action === 'logOutAndBlock') {
                await blockUser()
                doLogOut()
            } else if (ev.action === 'continue') {
                await activateUser()
                location.reload()
            } else {
                if (ev.action === '/cardRecharge') this.setIsInvoiceMode(false)
                this.$router.push(ev.action)
            }
        },
        dependentEvent: async function (ev) {
            if (ev.IDSITCONSUMI === '2') {
                this.currentCDCONSUMIDOR = ev.CDCONSUMIDOR
                this.showModalInfo({
                    type: 'defaultDialog',
                    text: 'O cartão deste dependente está bloqueado. Deseja desbloqueá-lo para liberar o acesso?',
                    icon: 'fas fa-credit-card',
                    open: true
                })
                return
            }
            if (ev.IDSITCONSUMI === 'A') {
                this.changeDependentMenuVisibility()
                return
            }
            this.setCurrentDependent(this.dependentsList.findIndex(d => d === ev))
            this.$router.push('/dependent')
        },
        cardAction: async function () {
            const cardStatus = '1' // 1 = desbloqueado
            await setCardStatus(this.currentCDCONSUMIDOR, cardStatus).then((res) => {
                if (res && res.rowsAffected) {
                    this.toggleCardStatusCDCONS({ CDCONSUMIDOR: this.currentCDCONSUMIDOR, newStatus: cardStatus }).then(() => {
                        showSuccessNotification({
                            title: '',
                            text: 'Cartão atualizado com sucesso.'
                        })
                    })
                }
            })
            this.currentCDCONSUMIDOR = ''
        },
        validateDependents: async function (dependent) {
            if (!dependent) {
                const message = 'É necessário adicionar pelo menos um dependente'
                this.messages.push(message)
                this.error = true
                return false
            }
            const CDCLIENTE = this.getBaseInfo.CDCLIENTE
            const result = await checkConsumerById(CDCLIENTE, dependent.ra)
            if (!result || result.error) {
                this.error = true
                result.message.forEach((e) => { this.messages.push(e) })
                this.showMessages()
                return false
            }
            return true
        },
        addDependent: async function (dependent) {
            const isValid = await this.validateDependents(dependent)
            if (isValid) {
                await registerDependents(dependent)
            }
        },
        showMessages: function () {
            this.messages.reverse().forEach(e => {
                showErrorNotification({
                    title: '',
                    text: e
                })
            })
            this.messages = []
        }
    },
    mounted () {
        setAppColors()
        this.showDefaultPasswordWarnModal()
        updateSonsAfterRecharge()
    }
}
</script>

<style lang="less" scoped>
.home-container {
    position: relative;
    display: block;
    height: 100%;
}
.termofuse{
    ::-webkit-scrollbar {
        width: 10px;
    }
    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: var(--primaryColor);
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: white;
    }
    position: relative;
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: calc(10vh - 0px) calc(75vh - 15px) calc(5vh - 0px) calc(10vh - 15px);
    font-family: Arial, Helvetica, sans-serif;
    .termtitle {
        text-align: center;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: center;
        align-items: center;
        text-transform: uppercase;
        font-weight: bold;
    }
    .termtext {
        position: relative;
        display: block;
        height: 95%;
        overflow: auto;
        text-align: justify;
        color: darkgray;
        padding: 0 15px;
    }
    .inpt-check {
        padding: 0 15px;
    }
    .button-container {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: flex-end;
        justify-content: center;
        align-items: center;
        height: 100%;
        position: relative;
        button {

        }
    }
}
</style>
